exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mix-picker>div[data-v-8f64efba]{display:grid;grid-gap:30px;grid-template-columns:repeat(5,1fr) 50px;padding-right:40px;position:relative\n}\n.mix-picker>div button[data-v-8f64efba]{top:40px\n}\n.add-another[data-v-8f64efba]{display:grid;grid-gap:30px;grid-template-columns:1fr 1fr 100px\n}\n.add-another .button[data-v-8f64efba],.add-another select[data-v-8f64efba]{margin:0\n}", ""]);

// exports
